<div *ngIf="lang === 'en'" class="tnc"
    [ngClass]="{ 'im3' : platform === 'im3', 'indosat' : platform === 'indosat' || platform === 'tri' }">
    <p>
        I consent to the implementation of Personalize Marketing activities of Products and Services by IOH which may
        involve collection and processing of My Personal Data by IOH or other parties collaborating with IOH for these
        activities.
    </p>
    <hr>
    <ol type="1">
        <li>
            To be able to use IOH customer’s personal related to the physical location of IOH customer’s devices
            combined with information about what advertisements IOH’s customers view and their usage habits of IOH
            services and/or products. This data will be shared with parties collaborating with IOH for the provision of
            personalized content and to assess the effectiveness of advertising campaigns of parties collaborating with
            IOH that match the target customer profile.
        </li>
        <li>
            To be able to use IOH customer's personal data related to habits in using and purchasing IOH products
            and/or services, tendencies to change numbers and location. This data will be shared with parties
            collaborating with IOH for further analysis. The analysis may encompass, among other things, credit risk
            assessment and the provision of additional telecommunications services. This may involve activities that
            involve collaboration with parties collaborating with IOH in the financial services sector and other
            sectors.
        </li>
        <li>
            To be able to use IOH customer's personal data related to habits in using IOH products and/or services to
            understand and categorize customers. The results of this process will create segmentation in customer
            profiles that will be shared with parties collaborating with IOH.
        </li>
        <li>
            To leverage IOH customer’s personal data related to their habits in using IOH products and/or services for
            further analysis for purposes determined by parties collaborating with IOH. Additionally, to carry out
            marketing process that is more in line with IOH customer preferences. This includes collaborating with
            parties who work with IOH to provide products and/or services offerings owned by held by related partners
            that are more in line with Your preferences, as recognized by IOH.
        </li>
    </ol>
</div>

<div *ngIf="lang === 'id'" class="tnc"
    [ngClass]="{ 'im3' : platform === 'im3', 'indosat' : platform === 'indosat' || platform === 'tri' }">
    <p>
        Saya menyetujui pelaksanaan kegiatan Pemasaran Terpersonalisasi atas Produk dan Layanan oleh IOH yang
        mungkin melibatkan pengumpulan dan pemrosesan Data Pribadi saya oleh IOH dengan pihak-pihak yang bekerja sama
        dengan IOH untuk kegiatan tersebut.
    </p>
    <hr>
    <ol type="1">
        <li>
            Untuk dapat menggunakan data pribadi pelanggan IOH terkait lokasi fisik perangkat pelanggan IOH yang
            dikombinasikan dengan informasi tentang iklan apa yang pelanggan IOH lihat dan kebiasaan penggunaan layanan
            dan/atau produk IOH. Data ini akan dibagikan kepada pihak-pihak yang bekerja sama dengan IOH untuk
            penyediaan konten yang telah dipersonalisasi dan untuk mempelajari efektivitas kampanye iklan pihak-pihak
            yang bekerja sama dengan IOH yang sesuai dengan profil pelanggan yang dituju.
        </li>
        <li>
            Untuk dapat menggunakan data pribadi pelanggan IOH terkait kebiasaan dalam penggunaan dan pembelian produk
            dan/ atau layanan IOH, kecenderungan untuk mengganti nomor, serta lokasi. Data ini akan dibagikan kepada
            pihak-pihak yang bekerja sama dengan IOH untuk dilakukan proses Analisa lebih lanjut. Analisa dapat
            mencakup, antara lain, penilaian risiko kredit dan penyediaan layanan telekomunikasi tambahan. Hal ini
            termasuk kegiatan yang melibatkan kolaborasi dengan pihak-pihak yang bekerja sama dengan IOH di sektor
            layanan keuangan dan sektor lainnya.

        </li>
        <li>
            Untuk dapat menggunakan data pribadi pelanggan IOH terkait kebiasaan dalam penggunaan produk dan/atau
            layanan IOH untuk memahami dan melakukan kategorisasi pelanggan. Hasil pemrosesan ini akan membuat
            segmentasi pada profil pelanggan yang dibagikan kepada pihak-pihak yang bekerja sama dengan IOH.

        </li>
        <li>
            Untuk memanfaatkan data pribadi pelanggan IOH terkait kebiasaan mereka dalam menggunakan produk dan/atau
            layanan IOH untuk analisis lebih lanjut untuk tujuan yang ditentukan oleh pihak-pihak yang bekerja sama
            dengan IOH. Selain itu, untuk menjalankan proses pemasaran yang lebih sejalan dengan preferensi pelanggan
            IOH. Hal ini termasuk berkolaborasi dengan pihak-pihak yang bekerja sama dengan IOH untuk memberikan
            penawaran produk dan/atau
        </li>
    </ol>
</div>